import React, { Component } from 'react';
import parse from 'html-react-parser';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { fade, MenuItem, Modal, Typography, useTheme } from '@material-ui/core';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import TablePagination from '@material-ui/core/TablePagination';
import AppBar from '@material-ui/core/AppBar';
import Popover from '@material-ui/core/Popover';

import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
//import Calendar from './index';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import CmtGridView from '../../../@coremat/CmtGridView';
import axios from 'axios';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  '@media screen and (max-width: 800px)': {
    width: '95%',
  },
  '@media screen and (min-width: 800px)': {
    width: 600,
  },
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

const useStyles = theme => ({
  boxTop: {
    paddingTop: theme.spacing(5),
  },
  appBar: {
    position: 'relative',
  },
  myButton: {
    margin: theme.spacing(2),
    minWidth: 200,
  },
  root: {
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },

  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  cardRoot: {
    '& .Cmt-header-root': {
      paddingTop: 10,
      paddingBottom: 0,
    },
  },
  tabsList: {
    position: 'relative',
    minHeight: 60,
    '& .MuiTabs-indicator': {
      backgroundColor: fade(theme.palette.primary.main, 0.8),
    },
  },
  tabItem: {
    maxWidth: 'none',
    minWidth: 10,
    minHeight: 60,
    padding: '5px 10px',
    textTransform: 'capitalize',
    color: theme.palette.text.primary,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightRegular,
  },
  columnRoot: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    letterSpacing: '0.5px',
  },
  table: {
    maxHeight: '50%',
  },
});
const DialogTitle = withStyles(useStyles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
}))(MuiDialogActions);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class SelectFolio extends Component {
  //
  //const [open, setOpen] = React.useState(this.props.open);
  constructor(props) {
    super(props);
    this.props = props;
    this.handleClose = this.handleClose.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      folioId: null,
    };
  }

  handleClickOpen() {
    //  setOpen(true);
  }

  handleChange(name, value) {
    this.setState({ [name]: value, changed: true }, () => {});
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.open != this.props.open) {
      this.setState({ folioId: this.props.folios[0].id });
    }
  }

  handleClose() {
    this.props.setState({ selectFolioVisible: false });
    //  setOpen(false);
  }

  handleSelect() {
    if (this.state.type == -1) return;
    this.props.moveFolio(this.state.folioId);
    this.props.setState({ selectFolioVisible: false });
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Modal
          open={this.props.open}
          onClose={this.handleClose}
          anchorEl={this.props.anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}>
          <Box sx={style}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <TextField
                  id="type"
                  label=<IntlMessages id="Folio" />
                  value={this.state.type}
                  select
                  fullWidth
                  onChange={event => this.handleChange('folioId', event.target.value)}>
                  {this.props.folios.map((item, index) => (
                    <MenuItem value={item.id}>{item.name}</MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.myButton}
                  onClick={() => this.handleClose()}
                  fullWidth>
                  <IntlMessages id="findClient.cancel" />
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.myButton}
                  onClick={() => this.handleSelect()}
                  fullWidth>
                  <IntlMessages id="invoice.moveItem" />
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

export default withStyles(useStyles)(connect(mapStateToProps)(SelectFolio));
